// extracted by mini-css-extract-plugin
export default {"darkClickableArea":"DarkClickableArea_darkClickableArea__prkGK","darkClickableArea_fixed":"DarkClickableArea_darkClickableArea_fixed__RCPzE"};